import React from 'react';
import GenericModal from './GenericModal';
import Logo from '../logo/Logo';

const Loading = () => {
    return (<GenericModal
        div={<div className="animate__animated animate__heartBeat animate__slow animate__infinite"><Logo /></div>}
    />)
}
export default Loading;